<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
    <basic-table
      v-if="replacementsInDocument"
      :items="replacementsInDocument"
      :fields="replacementsInDocumentFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedReplacementsInDocument"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      replacementsInDocumentFields: [
        {key: 'key', label: this.$i18n.t('Key'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedReplacementsInDocument: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedReplacementsInDocument = {
        id: 0,
        key: '',
        value: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditReplacementsInDocument', '#btnShow')
    },
    editItem (item) {
      this.selectedReplacementsInDocument = item
      this.selectedReplacementsInDocument.id = 1
      this.$root.$emit('bv::show::modal', 'modalEditReplacementsInDocument', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Replacements in document"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_REPLACEMENTS_IN_DOCUMENT', item.key)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_REPLACEMENTS_IN_DOCUMENT')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    replacementsInDocument () {
      return this.$store.getters['Settings/REPLACEMENTS_IN_DOCUMENT']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REPLACEMENTS_IN_DOCUMENT')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/replacementsInDocument/main.vue